// extracted by mini-css-extract-plugin
export default {"cls1":"xtri2T2uu32ulJ6mFP1S","cls2":"H28YuCU9YLNWYHYYba1T xtri2T2uu32ulJ6mFP1S"};